"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonTranslations = {
    companyName: "Home Health Notify",
    welcome: "Welcome",
    logout: "Logout",
    supportEmailId: "support@homehealthnotify.com",
    filter: {
        messageFilter: "Messages Filter",
        applyButton: "Apply",
        resetButton: "Reset",
        patientStatus: "Filter by patient status",
        serviceStatus: "Filter by service",
        chatsBy: "Filter chats by",
        date: "Date",
        unreadMessages: "Unread Messages",
    },
    buttonLabels: {
        update: "Update",
        next: "Next",
        updating: "Updating",
        adding: "Adding",
        back: "Back",
        submit: "Submit",
        save: "Save",
        addNew: "Add New",
        skip: "Skip",
        ok: "OK",
        cancel: "Cancel",
        delete: "Delete",
        done: "Done",
    },
    emptyRecordMessage: "No Record found",
    emptySearchRecordMessage: "No search record found",
    endOfTheListMessage: "This is end of the list",
    editBroadcast: "Edit Broadcast",
    serviceStatusLabel: {
        pending: "Pending",
        active: "Active",
        discharged: "Discharged",
    },
    notApplicable: "N/A",
    notImplemented: "Feature not implemented yet!",
    callDrawerHeader: "Select Members to call",
    errors: {
        patientDuplicate: "Patient with same name and date of birth already exists",
        groupNotAvailable: "This group is no longer available",
        chatDeleted: "This chat has been deleted",
        chatDeletedNamed: "{{name}} has been deleted",
        generic: "Oops! Something went wrong, try again later!",
    },
};
exports.default = commonTranslations;
